import { ModalSurface } from './ModalSurface';
import type { SurfaceProps } from './common';

/** Celoobrazovkový pop-up — modál s roztaženou kartou. */
export function FullscreenSurface(props: SurfaceProps) {
  return <ModalSurface {...props} fullscreen />;
}
